$(document).ready(function() {
    $.validator.messages.required = msg['ERR_MISSINGFIELDS'];
    $.validator.messages.email = msg['ERR_INVALIDMAIL'];
});